import type { FC } from "react";

import { PromptDataProfilesSearchForm } from "src/app/features/PromptDataProfile/components/forms/PromptDataProfilesSearchForm";
import { PromptDataProfilesTable } from "src/app/features/PromptDataProfile/components/tables/PromptDataProfilesTable";
import type { PromptDataProfileList } from "src/app/features/PromptDataProfile/types/PromptDataProfileList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const PromptDataProfilesPage: FC<NoneOwnProps> = () => {
    const table = <PromptDataProfilesTable />;
    const searchForm = <PromptDataProfilesSearchForm />;
    const hasAccess = canAccess(ResourceName.PROMPT_DATA_PROFILES, "canRead");

    return (
        <PageLayout name="promptDataProfiles_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.promptData" />
                    <ResourceManager<PromptDataProfileList>
                        useDataGroup
                        dataMapperKey="promptDataProfilesTableData"
                        resource={ResourceName.PROMPT_DATA_PROFILES}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.FORM_COPY, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
